<template>
  <main class="collection">
    <div class="title lundi no-select">
        {{ collection.title }}
    </div>
    <div class="grid g-6 b-rw">
      <div
        v-for="(item, index) in collection.items"
        :key="index"
        class="item b-b b-r collection-item"
        :class="item.width + ' ' + item.type"
      >
        <template v-if="item.type == 'text'">
            <div class="sli" v-html="item.text"></div>
        </template>
        <template v-if="item.type == 'image'">
          <router-link
            v-if="item.pagelink"
            :to="{ path: '/' + item.pagelink.parent + '/' + item.pagelink.uid }"
          >
            <img v-lazy="item.image.url" :src="item.image.thumb" alt="" />
          </router-link>
          <img v-else v-lazy="item.image.url" :src="item.image.thumb" alt="" />
        </template>
        <template v-if="item.type == 'video'">
          <video
            v-if="item.video"
            :src="item.video.url"
            playsinline
            autoplay
            muted
            loop
          ></video>
        </template>
        <template v-if="item.type == 'marquee'">
          <div class="marquee lundi">
            <div class="marquee-inner">
              <div class="marquee-text">{{ item.marquee }}</div>
              <div class="marquee-text">{{ item.marquee }}</div>
              <div class="marquee-text">{{ item.marquee }}</div>
              <div class="marquee-text">{{ item.marquee }}</div>
              <div class="marquee-text">{{ item.marquee }}</div>
              <div class="marquee-text">{{ item.marquee }}</div>
              <div class="marquee-text">{{ item.marquee }}</div>
              <div class="marquee-text">{{ item.marquee }}</div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  data() {
    return {
      videoCount: 0,
      videoLength: null
    };
  },
  created() {
    if (this.$store.state.collections.length === 0) {
      this.$store.dispatch("loadCollections", this.$route.name + 's');
    }
  },
  computed: {
    collection() {
        return this.$store.getters.getCollectionByUID(this.$route.name + 's', this.$route.params.id);
    }
  }
};
</script>

<style lang="scss">
.title {
  position: fixed;
  left: 50%;
  top: 50%;
  font-size: calc(8 * 1vw);
  line-height: 1;
  letter-spacing: 0.3vw;
  transform: translate(-50%, -50%);
  white-space: nowrap;
  text-transform: uppercase;
  color: var(--orange);
  mix-blend-mode: difference;
  z-index: 3;
  pointer-events: none;
}
.item.collection-item {
  overflow: hidden;
  @media only screen and (max-width:768px) {
      grid-column: span 12 !important;
  }
}
.item.collection-item.image, .item.collection-item.video {
      @media only screen and (max-width:768px) {
            height:60vh !important;
      }  
}
img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
}
video {
  width: 101%;
  height: 110%;
  object-fit: cover;
  display: block;
}
.text-block {
    padding: var(--lh);
}
.text {
      @media only screen and (max-width:768px) {
            grid-column: span 12 !important;
      }
}
.marquee {
  display: block;
  background: var(--orange);
  width: 100%;
  height: calc(2 * var(--lh));
  overflow: hidden;
  position: relative;
  color: white;
  box-sizing: border-box;
  .marquee-inner {
    position: absolute;
    box-sizing: border-box;
    top: 0;
    left: 0;
    transform: translateX(0);
    animation: marquee 10s infinite linear;
    white-space: nowrap;
    .marquee-text {
      box-sizing: border-box;
      display: inline-block;
      padding: calc(0.5 * var(--lh)) calc(4 * var(--lh));
    }
  }
}
@keyframes marquee {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-12.5%);
  }
}
</style>
